import type { DocumentTypes } from 'contentlayer/generated';
import { useMDXComponent } from 'next-contentlayer2/hooks';
import { useRouter } from 'next/router';

export interface UseContentProps {
  content: DocumentTypes;
}

export const useContent = ({ content }: UseContentProps) => {
  const router = useRouter();

  if (content?.body.code == null) router.push('/404');
  const Component = useMDXComponent(content?.body.code ?? '');

  return Component;
};
